import { Backdrop, CircularProgress, Dialog, DialogContentText, DialogTitle } from '@mui/material';
import { useContext, useEffect,useState } from "react";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { ModalpropsCustom } from "../../utils/constants";
import { SimpleDialog } from "../modals/modal-basics";





export const GlobalComponents = ({children})=>{

    
    const {dispatch,store} = useContext( AppContext );

    const {isLoadingApp,modalProps}  = store;

   const selfCloseModal = ()=>{
    dispatch({
        type:ActionTypes.setModalInfo,
        data:{...ModalpropsCustom}
    });
   }
    

return <>

<Backdrop
  sx={{ color: 'primary.contrastText', zIndex: (theme) => theme.zIndex.drawer + 100000 }}
  open={isLoadingApp}

>
  <CircularProgress color="primary" />
</Backdrop>

<SimpleDialog  selfCloseModal={selfCloseModal} {...modalProps} />

{
    children
}

</>
    
}